import actions from "./actions";

const initState = {
    transactionReadAllState: false,
    transactions: [],
    searchTerm: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SEARCH_READ_TRANSACTIONS_REQUEST:
            return {
                ...state,
                transactionReadAllState: 'request',
            };
        case actions.SEARCH_READ_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactionReadAllState: 'success',
                transactions: action.transactions,
            };
        case actions.SEARCH_READ_TRANSACTIONS_ERROR:
            return {
                ...state,
                transactionReadAllState: 'error',
            };
        case actions.SEARCH_CACHE_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.searchTerm,
            };
        default:
            return state;
    }
}
